/* tslint:disable */
/* eslint-disable */
/* @relayHash 77274fb590a0bf2ed2573e74da45fbc3 */

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ConversationThreadContainerPaginationQueryVariables = {
    count: number;
    cursor?: unknown | null;
    commentID: string;
};
export type ConversationThreadContainerPaginationQueryResponse = {
    readonly comment: {
        readonly " $fragmentRefs": FragmentRefs<"ConversationThreadContainer_comment">;
    } | null;
};
export type ConversationThreadContainerPaginationQuery = {
    readonly response: ConversationThreadContainerPaginationQueryResponse;
    readonly variables: ConversationThreadContainerPaginationQueryVariables;
};



/*
query ConversationThreadContainerPaginationQuery(
  $count: Int!
  $cursor: Cursor
  $commentID: ID!
) {
  comment(id: $commentID) {
    ...ConversationThreadContainer_comment_1G22uz
    id
  }
}

fragment ArchivedReportFlowContainer_comment on Comment {
  id
  story {
    url
    id
  }
}

fragment CaretContainer_comment on Comment {
  id
  ...ModerationDropdownContainer_comment
}

fragment CommentContainer_comment on Comment {
  id
  author {
    id
    username
    avatar
    badges
    featuredCommenter
    newCommenter
  }
  parent {
    id
    author {
      username
      id
    }
  }
  body
  createdAt
  status
  rating
  editing {
    edited
    editableUntil
  }
  tags {
    code
  }
  deleted
  actionCounts {
    reaction {
      total
    }
  }
  viewerActionPresence {
    dontAgree
    flag
  }
  seen
  canReply
  ...CaretContainer_comment
  ...EditCommentFormContainer_comment
  ...MediaSectionContainer_comment
  ...ReactionButtonContainer_comment
  ...ModerationRejectedTombstoneContainer_comment
  ...ReplyCommentFormContainer_comment
  ...ReportButton_comment
  ...ReportFlowContainer_comment
  ...UsernameContainer_comment
  ...UsernameWithPopoverContainer_comment
  ...UserTagsContainer_comment
  ...ArchivedReportFlowContainer_comment
}

fragment ConversationThreadContainer_comment_1G22uz on Comment {
  id
  ...CommentContainer_comment
  ...IgnoredTombstoneOrHideContainer_comment
  ...RejectedTombstoneContainer_comment
  ...DeletedTombstoneContainer_comment
  rootParent {
    id
    author {
      id
      username
    }
    createdAt
    ...UserTagsContainer_comment
    ...CommentContainer_comment
    ...IgnoredTombstoneOrHideContainer_comment
    ...LocalReplyListContainer_comment
    ...RejectedTombstoneContainer_comment
    ...DeletedTombstoneContainer_comment
  }
  parentCount
  parents(last: $count, before: $cursor) {
    edges {
      node {
        id
        ...CommentContainer_comment
        ...LocalReplyListContainer_comment
        ...IgnoredTombstoneOrHideContainer_comment
        ...RejectedTombstoneContainer_comment
        ...DeletedTombstoneContainer_comment
        __typename
      }
      cursor
    }
    pageInfo {
      hasPreviousPage
      startCursor
    }
  }
}

fragment CopyCommentEmbedCodeContainer_comment on Comment {
  id
  author {
    id
    username
  }
  body
  revision {
    id
    media {
      __typename
      ... on GiphyMedia {
        url
      }
      ... on TwitterMedia {
        url
      }
      ... on BlueskyMedia {
        url
      }
      ... on YouTubeMedia {
        url
      }
      ... on ExternalMedia {
        url
      }
    }
  }
}

fragment DeletedTombstoneContainer_comment on Comment {
  deleted
  id
}

fragment EditCommentFormContainer_comment on Comment {
  id
  body
  createdAt
  revision {
    id
    media {
      __typename
      ... on GiphyMedia {
        url
        title
        width
        height
        still
        video
      }
      ... on TenorMedia {
        url
        title
      }
      ... on TwitterMedia {
        url
        width
      }
      ... on BlueskyMedia {
        url
        width
      }
      ... on YouTubeMedia {
        url
        width
        height
      }
      ... on ExternalMedia {
        url
      }
    }
  }
  author {
    username
    id
  }
  editing {
    editableUntil
  }
  site {
    id
  }
}

fragment IgnoredTombstoneOrHideContainer_comment on Comment {
  id
  author {
    id
    username
  }
}

fragment LocalReplyListContainer_comment on Comment {
  id
}

fragment MediaSectionContainer_comment on Comment {
  id
  site {
    id
  }
  revision {
    media {
      __typename
      ... on GiphyMedia {
        url
        title
        width
        height
        still
        video
      }
      ... on TenorMedia {
        url
      }
      ... on TwitterMedia {
        url
        width
      }
      ... on BlueskyMedia {
        url
        width
      }
      ... on YouTubeMedia {
        url
        width
        height
      }
      ... on ExternalMedia {
        url
      }
    }
    id
  }
}

fragment ModerationActionsContainer_comment on Comment {
  id
  author {
    id
  }
  body
  revision {
    id
  }
  status
  tags {
    code
  }
  ...CopyCommentEmbedCodeContainer_comment
}

fragment ModerationDropdownContainer_comment on Comment {
  id
  author {
    id
    username
  }
  revision {
    id
  }
  status
  tags {
    code
  }
  ...ModerationActionsContainer_comment
  ...UserBanPopoverContainer_comment
}

fragment ModerationRejectedTombstoneContainer_comment on Comment {
  id
  ...CaretContainer_comment
}

fragment ReactionButtonContainer_comment on Comment {
  id
  author {
    id
    username
  }
  revision {
    id
  }
  viewerActionPresence {
    reaction
  }
  actionCounts {
    reaction {
      total
    }
  }
}

fragment RejectedTombstoneContainer_comment on Comment {
  id
  status
}

fragment ReplyCommentFormContainer_comment on Comment {
  id
  site {
    id
  }
  author {
    username
    id
  }
  revision {
    id
  }
  ...ReplyEditedWarningContainer_comment
}

fragment ReplyEditedWarningContainer_comment on Comment {
  editing {
    edited
  }
  revision {
    id
  }
}

fragment ReportButton_comment on Comment {
  id
  author {
    username
    id
  }
  viewerActionPresence {
    dontAgree
    flag
    illegal
  }
}

fragment ReportCommentFormContainer_comment on Comment {
  id
  revision {
    id
  }
  story {
    url
    id
  }
}

fragment ReportFlowContainer_comment on Comment {
  ...ReportCommentFormContainer_comment
  id
  viewerActionPresence {
    dontAgree
    flag
  }
}

fragment UserBanPopoverContainer_comment on Comment {
  id
  revision {
    id
  }
  status
  author {
    id
    username
  }
}

fragment UserIgnorePopoverContainer_user on User {
  id
  username
}

fragment UserPopoverContainer_user on User {
  id
  ...UserPopoverOverviewContainer_user
  ...UserIgnorePopoverContainer_user
}

fragment UserPopoverOverviewContainer_user on User {
  id
  username
  createdAt
  ignoreable
  bio
}

fragment UserTagsContainer_comment on Comment {
  tags {
    code
  }
}

fragment UsernameContainer_comment on Comment {
  id
  author {
    username
    id
  }
}

fragment UsernameWithPopoverContainer_comment on Comment {
  id
  author {
    id
    username
    ...UserPopoverContainer_user
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = ({
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "commentID"
    } as any), v1 = ({
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "count"
    } as any), v2 = ({
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cursor"
    } as any), v3 = [
        ({
            "kind": "Variable",
            "name": "id",
            "variableName": "commentID"
        } as any)
    ], v4 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any), v5 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "username",
        "storageKey": null
    } as any), v6 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdAt",
        "storageKey": null
    } as any), v7 = ({
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "author",
        "plural": false,
        "selections": [
            (v4 /*: any*/),
            (v5 /*: any*/),
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "avatar",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "badges",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "featuredCommenter",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "newCommenter",
                "storageKey": null
            },
            (v6 /*: any*/),
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "ignoreable",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "bio",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v8 = ({
        "alias": null,
        "args": null,
        "concreteType": "Comment",
        "kind": "LinkedField",
        "name": "parent",
        "plural": false,
        "selections": [
            (v4 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "author",
                "plural": false,
                "selections": [
                    (v5 /*: any*/),
                    (v4 /*: any*/)
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v9 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "body",
        "storageKey": null
    } as any), v10 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
    } as any), v11 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "rating",
        "storageKey": null
    } as any), v12 = ({
        "alias": null,
        "args": null,
        "concreteType": "EditInfo",
        "kind": "LinkedField",
        "name": "editing",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "edited",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "editableUntil",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v13 = ({
        "alias": null,
        "args": null,
        "concreteType": "Tag",
        "kind": "LinkedField",
        "name": "tags",
        "plural": true,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "code",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v14 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deleted",
        "storageKey": null
    } as any), v15 = ({
        "alias": null,
        "args": null,
        "concreteType": "ActionCounts",
        "kind": "LinkedField",
        "name": "actionCounts",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "ReactionActionCounts",
                "kind": "LinkedField",
                "name": "reaction",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "total",
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v16 = ({
        "alias": null,
        "args": null,
        "concreteType": "ActionPresence",
        "kind": "LinkedField",
        "name": "viewerActionPresence",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "dontAgree",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "flag",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "reaction",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "illegal",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v17 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "seen",
        "storageKey": null
    } as any), v18 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "canReply",
        "storageKey": null
    } as any), v19 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    } as any), v20 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "url",
        "storageKey": null
    } as any), v21 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "title",
        "storageKey": null
    } as any), v22 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "width",
        "storageKey": null
    } as any), v23 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "height",
        "storageKey": null
    } as any), v24 = [
        (v20 /*: any*/),
        (v22 /*: any*/)
    ], v25 = ({
        "alias": null,
        "args": null,
        "concreteType": "CommentRevision",
        "kind": "LinkedField",
        "name": "revision",
        "plural": false,
        "selections": [
            (v4 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "media",
                "plural": false,
                "selections": [
                    (v19 /*: any*/),
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            (v20 /*: any*/),
                            (v21 /*: any*/),
                            (v22 /*: any*/),
                            (v23 /*: any*/),
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "still",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "video",
                                "storageKey": null
                            }
                        ],
                        "type": "GiphyMedia",
                        "abstractKey": null
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": (v24 /*: any*/),
                        "type": "TwitterMedia",
                        "abstractKey": null
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": (v24 /*: any*/),
                        "type": "BlueskyMedia",
                        "abstractKey": null
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            (v20 /*: any*/),
                            (v22 /*: any*/),
                            (v23 /*: any*/)
                        ],
                        "type": "YouTubeMedia",
                        "abstractKey": null
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            (v20 /*: any*/)
                        ],
                        "type": "ExternalMedia",
                        "abstractKey": null
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            (v20 /*: any*/),
                            (v21 /*: any*/)
                        ],
                        "type": "TenorMedia",
                        "abstractKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v26 = ({
        "alias": null,
        "args": null,
        "concreteType": "Site",
        "kind": "LinkedField",
        "name": "site",
        "plural": false,
        "selections": [
            (v4 /*: any*/)
        ],
        "storageKey": null
    } as any), v27 = ({
        "alias": null,
        "args": null,
        "concreteType": "Story",
        "kind": "LinkedField",
        "name": "story",
        "plural": false,
        "selections": [
            (v20 /*: any*/),
            (v4 /*: any*/)
        ],
        "storageKey": null
    } as any), v28 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "spamBanned",
        "storageKey": null
    } as any), v29 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "pending",
        "storageKey": null
    } as any), v30 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lastViewerAction",
        "storageKey": null
    } as any), v31 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hasTraversalFocus",
        "storageKey": null
    } as any), v32 = ({
        "kind": "ClientExtension",
        "selections": [
            (v28 /*: any*/),
            (v29 /*: any*/),
            (v30 /*: any*/),
            (v31 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "Comment",
                "kind": "LinkedField",
                "name": "localReplies",
                "plural": true,
                "selections": [
                    (v4 /*: any*/),
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "enteredLive",
                        "storageKey": null
                    },
                    (v30 /*: any*/),
                    (v7 /*: any*/),
                    (v8 /*: any*/),
                    (v9 /*: any*/),
                    (v6 /*: any*/),
                    (v10 /*: any*/),
                    (v11 /*: any*/),
                    (v12 /*: any*/),
                    (v13 /*: any*/),
                    (v29 /*: any*/),
                    (v14 /*: any*/),
                    (v15 /*: any*/),
                    (v16 /*: any*/),
                    (v31 /*: any*/),
                    (v17 /*: any*/),
                    (v18 /*: any*/),
                    (v28 /*: any*/),
                    (v25 /*: any*/),
                    (v26 /*: any*/),
                    (v27 /*: any*/)
                ],
                "storageKey": null
            }
        ]
    } as any), v33 = [
        ({
            "kind": "Variable",
            "name": "before",
            "variableName": "cursor"
        } as any),
        ({
            "kind": "Variable",
            "name": "last",
            "variableName": "count"
        } as any)
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                (v0 /*: any*/),
                (v1 /*: any*/),
                (v2 /*: any*/)
            ],
            "kind": "Fragment",
            "metadata": null,
            "name": "ConversationThreadContainerPaginationQuery",
            "selections": [
                {
                    "alias": null,
                    "args": (v3 /*: any*/),
                    "concreteType": "Comment",
                    "kind": "LinkedField",
                    "name": "comment",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "count",
                                    "variableName": "count"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "cursor",
                                    "variableName": "cursor"
                                }
                            ],
                            "kind": "FragmentSpread",
                            "name": "ConversationThreadContainer_comment"
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                (v1 /*: any*/),
                (v2 /*: any*/),
                (v0 /*: any*/)
            ],
            "kind": "Operation",
            "name": "ConversationThreadContainerPaginationQuery",
            "selections": [
                {
                    "alias": null,
                    "args": (v3 /*: any*/),
                    "concreteType": "Comment",
                    "kind": "LinkedField",
                    "name": "comment",
                    "plural": false,
                    "selections": [
                        (v4 /*: any*/),
                        (v7 /*: any*/),
                        (v8 /*: any*/),
                        (v9 /*: any*/),
                        (v6 /*: any*/),
                        (v10 /*: any*/),
                        (v11 /*: any*/),
                        (v12 /*: any*/),
                        (v13 /*: any*/),
                        (v14 /*: any*/),
                        (v15 /*: any*/),
                        (v16 /*: any*/),
                        (v17 /*: any*/),
                        (v18 /*: any*/),
                        (v25 /*: any*/),
                        (v26 /*: any*/),
                        (v27 /*: any*/),
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "rootParent",
                            "plural": false,
                            "selections": [
                                (v4 /*: any*/),
                                (v7 /*: any*/),
                                (v6 /*: any*/),
                                (v13 /*: any*/),
                                (v8 /*: any*/),
                                (v9 /*: any*/),
                                (v10 /*: any*/),
                                (v11 /*: any*/),
                                (v12 /*: any*/),
                                (v14 /*: any*/),
                                (v15 /*: any*/),
                                (v16 /*: any*/),
                                (v17 /*: any*/),
                                (v18 /*: any*/),
                                (v25 /*: any*/),
                                (v26 /*: any*/),
                                (v27 /*: any*/),
                                (v32 /*: any*/)
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "parentCount",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": (v33 /*: any*/),
                            "concreteType": "CommentsConnection",
                            "kind": "LinkedField",
                            "name": "parents",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "CommentEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Comment",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                (v4 /*: any*/),
                                                (v7 /*: any*/),
                                                (v8 /*: any*/),
                                                (v9 /*: any*/),
                                                (v6 /*: any*/),
                                                (v10 /*: any*/),
                                                (v11 /*: any*/),
                                                (v12 /*: any*/),
                                                (v13 /*: any*/),
                                                (v14 /*: any*/),
                                                (v15 /*: any*/),
                                                (v16 /*: any*/),
                                                (v17 /*: any*/),
                                                (v18 /*: any*/),
                                                (v25 /*: any*/),
                                                (v26 /*: any*/),
                                                (v27 /*: any*/),
                                                (v19 /*: any*/),
                                                (v32 /*: any*/)
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "cursor",
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "hasPreviousPage",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "startCursor",
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": (v33 /*: any*/),
                            "filters": null,
                            "handle": "connection",
                            "key": "ConversationThread_parents",
                            "kind": "LinkedHandle",
                            "name": "parents"
                        },
                        {
                            "kind": "ClientExtension",
                            "selections": [
                                (v28 /*: any*/),
                                (v29 /*: any*/),
                                (v30 /*: any*/),
                                (v31 /*: any*/)
                            ]
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "id": "77274fb590a0bf2ed2573e74da45fbc3",
            "metadata": {},
            "name": "ConversationThreadContainerPaginationQuery",
            "operationKind": "query",
            "text": null
        }
    } as any;
})();
(node as any).hash = '1a359b3a83b64613402d20d92b89c7ae';
export default node;
